import { useTranslation } from 'react-i18next'
import DeleteIcon from '@mui/icons-material/Delete'
import _ from 'lodash'
import ActionButton from './ActionButton'
import ConfirmableButton from './ConfirmableButton'

const DeleteButton = (props) => {
  const {
    dialog,
    icon = props.label ? undefined : <DeleteIcon />,
    label,
    ...rest
  } = props

  const { t } = useTranslation()

  return rest.onConfirmed ? (
    <ConfirmableButton
      dialog={_.merge(
        {
          actions: { confirm: t('ui.delete') },
          error: true,
        },
        dialog
      )}
      icon={icon}
      label={label}
      {...rest}
    />
  ) : (
    <ActionButton icon={icon} label={label} {...rest} />
  )
}

DeleteButton.propTypes = ConfirmableButton.propTypes

export default DeleteButton
